import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from '../../core/service/theme.service';
import { Theme } from '../../core/models/theme.model';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  contentSectionHeight = 0;
  menuActive: boolean;
  config: Theme;
  subscription: Subscription;
  slideContentLeft: boolean;
  slideContentRight: boolean;
  hiddenHeader: boolean;
  fullMenu: boolean;

  constructor(private configService: ThemeService) {}

  ngOnInit(): void {
    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(
      (config) => (this.config = config)
    );

    this.calculateContentSectionHeight();
  }

  onMaskClick(): void {
    this.hideMenu();
  }

  hideMenu(): void {
    this.menuActive = false;
    this.removeClass(document.body, 'blocked-scroll');
  }

  removeClass(element: any, className: string): void {
    if (element.classList) {
      element.classList.remove(className);
    } else {
      element.className = element.className.replace(
        new RegExp(
          '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
          'gi'
        ),
        ' '
      );
    }
  }

  onMenuButtonClick(): void {
    this.menuActive = true;
    this.addClass(document.body, 'blocked-scroll');
  }

  onMenuToggleClick($event): void {
    if ($event.direction == 'rtl') {
      this.slideContentRight = !$event.closed;
      this.slideContentLeft = false;
    } else {
      this.slideContentLeft = !$event.closed;
      this.slideContentRight = false;
    }
  }

  addClass(element: any, className: string): void {
    if (element.classList) {
      element.classList.add(className);
    } else {
      element.className += ' ' + className;
    }
  }

  onToggleHeaderClick(hiddenHeader: boolean) {
    this.hiddenHeader = hiddenHeader;
    this.fullMenu = hiddenHeader;
  }

  private calculateContentSectionHeight() {
    const headerHeight = 70;
    const togglerHeight = 45;

    this.contentSectionHeight =
      window.innerHeight - (headerHeight + togglerHeight);
  }
}
